import React from "react"
import { Pane, Text } from "evergreen-ui"
import { isFunction } from "lodash"

const ogCreateElement = React.createElement.bind(React)

window.articleWidth = 704

window.React = React

window.Component = React.Component

class Surface extends React.Component {
  state = { isHovering: false }
  render() {
    const { isHovering } = this.state
    const { children, ...props } = this.props

    const addMouseEvents = isFunction(children)
      ? {
          onMouseEnter: e => {
            this.setState({ isHovering: true })
            if (this.props.onMouseEnter) {
              this.props.onMouseEnter(e)
            }
          },
          onMouseLeave: e => {
            this.setState({ isHovering: false })
            if (this.props.onMouseLeae) {
              this.props.onMouseLeave(e)
            }
          },
        }
      : {}

    return (
      <Pane display="flex" flexFlow="column" {...props} {...addMouseEvents}>
        {isFunction(children) ? children(isHovering) : children}
      </Pane>
    )
  }
}

window.Text = props => <Text color="black" {...props} />
window.Paragraph = ({ children, ...props }) => (
  <Text
    gridColumn="text"
    fontSize={17}
    lineHeight={1.5}
    marginY={10}
    color="black"
    {...props}
  >
    {children}
  </Text>
)

window.FigureHeading = ({ children, ...props }) => (
  <Surface
    marginTop={10}
    borderBottom
    paddingBottom={14}
    marginBottom={20}
    width={articleWidth}
    alignSelf="center"
  >
    <Text
      color="black"
      fontSize={18}
      marginLeft={10}
      lineHeight="20px"
      fontWeight={600}
      {...props}
    >
      {children}
    </Text>
  </Surface>
)

window.Heading2 = ({ fontSize = 20, children, ...props }) => (
  <Surface marginTop={40} marginBottom={20} gridColumn="text">
    <Text color="black" fontSize={fontSize} fontWeight={600} {...props}>
      {children}
    </Text>
  </Surface>
)

window.ZoomedImg = ({ src, size, padding, style, ...props }) => (
  <div
    style={Object.assign(
      {},
      {
        width: size,
        height: size,
        overflow: "hidden",
        borderRadius: 5,
        position: "relative",
      },
      style,
    )}
    {...props}
  >
    <img
      src={src}
      width={size + padding * 2}
      height={size + padding * 2}
      style={{ position: "absolute", left: -padding, top: -padding }}
    />
  </div>
)

window.Heading = ({ fontSize = 30, children, ...props }) => (
  <Surface
    borderBottom
    marginTop={32}
    marginBottom={24}
    paddingBottom={16}
    gridColumn="text"
  >
    <Text
      color="black"
      fontSize={fontSize}
      lineHeight="20px"
      fontWeight={600}
      {...props}
    >
      {children}
    </Text>
  </Surface>
)

const neuronFeatureVisBase = (modelName, layer, neuron) => {
  return `https://storage.googleapis.com/fls/nickc/neuron_renders/${layer}_${neuron}.jpg`
}

window.neuronFeatureVis = (modelName, layer, neuron) => {
  if (modelName === "inceptionv1") {
    return neuronFeatureVisBase(modelName, layer, neuron)
  }

  return `https://storage.googleapis.com/clarity-public/nick/feature_visualizations/${modelName}/${layer.replace(
    /\//g,
    "_",
  )}/${neuron}.jpg`
}

window.Surface = Surface
